import { FormControl, InputLabel, MenuItem, Paper, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Select from "@mui/material/Select";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Edit, Delete, QrCode2 } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { Modal } from "react-bootstrap";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import '../Categories/Categories.css'
import { toast } from "react-toastify";
import dayjs from "dayjs";
import {  newHost } from "../Categories/CategoryProfile";
import axios from "axios";
import DeleteModal from "../../components/Modals/DeleteModal";
import NotFound from "../../components/SharedModule/NotFound";
import { useSelector } from "react-redux";

export default function Batches() {

const { user } = useSelector((state) => state.auth);
      
    const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const { id, subCatId, brandId, productId } = useParams();

  const navigate = useNavigate();

  const [batches, setBatches] = useState([]);

  const getBatches = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/stock_batches?variation_id=${productId}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      setBatches(response.data.data.stock_batches);
    } catch (error) {
      console.log();
    }
  };

  const goToProductInfo = () => {
    navigate(
        id && subCatId && brandId && productId
        ? `/Categories/${id}/subcategory/${subCatId}/brand/${brandId}/Products/${productId}`
        : id && brandId && productId
        ? `/Categories/${id}/brand/${brandId}/Products/${productId}`
        : id && productId
        ? `/Brands/${id}/Products/${productId}`
        : `/stock/${productId}`
    );
  };

  const goToBarCode = (batchId) => {
    navigate(
      id && subCatId && brandId && productId
        ? `/Categories/${id}/subcategory/${subCatId}/brand/${brandId}/Products/${productId}/Batches/${batchId}BarCode`
        : id && brandId && productId
        ? `/Categories/${id}/brand/${brandId}/Products/${productId}/Batches/${batchId}/BarCode`
        : id && productId
        ? `/Brands/${id}/Products/${productId}/Batches/${batchId}/BarCode`
        : `/stock/${productId}/batches/${batchId}/BarCode`
    );
  };

  const columns = [
    {
      field: "Code",
      headerName: "Code",
      flex: .6,
      minWidth: 80,
    },
    {
      field: "Supplier",
      headerName: "Supplier Name",
      flex: 1,
      minWidth: 145,
    },
    {
      field: "Quantity",
      headerName: "Quantity",
      flex: 0.8,
      minWidth: 90,
    },
    {
      field: "Remaining",
      headerName: "Remaining",
      flex: .8,
      minWidth: 90,
    },
    {
      field: "Expiry",
      headerName: "Expiry Date",
      flex: .9,
      minWidth: 100,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 0.6,
      minWidth: 70,
    },
    {
      field: "Purchase",
      headerName: "Purchase Price",
      flex: .9,
      minWidth: 110,
    },
    {
      field: "Selling",
      headerName: "Selling Price",
      flex: .9,
      minWidth: 110,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 170,
      renderCell: (params) => {
        const handleEdit = (event) => {
          event.stopPropagation();
          handleEditCategory(params.row.id);
        };

        const handleDelete = (event) => {
          event.stopPropagation();
          confirmDelete(params.row.id)
        };

        const handleBarCode = (event) => {
          event.stopPropagation();
          goToBarCode(params.row.id);
        };
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={handleBarCode}
              color="info"
              style={{ width: "30%" }}
              aria-label="barcode"
            >
              <QrCode2 />
            </IconButton>
            <IconButton
              onClick={handleEdit}
              color="default"
              style={{ width: "30%" }}
              aria-label="edit"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={handleDelete}
              color="error"
              style={{ width: "30%" }}
              aria-label="delete"
            >
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const rows = batches.map((batch) => ({
    id: batch.id,
    Code : batch.batch_code,
    Supplier: batch?.supplier?.name,
    Quantity: batch.quantity,
    Remaining : batch.remaining_quantity ,
    Expiry: batch.expiration_date,
    Status: batch.status,
    Purchase: batch.purchase_price,
    Selling: batch.selling_price,
  }));

  const paginationModel = { page: 0, pageSize: 10 };

  //  add & update batches

  const [providers, setProviders] = useState([]);

  const [providerId, setProviderId] = useState(null);

  const getProviders = async () => {
    try {
      const response = await axios.get(`${newHost}portal/providers`, {
        headers: newHeaders,
      });
      console.log(response);
      setProviders(response.data.data?.providers);
    } catch (error) {
      console.log();
    }
  };

  const [branches, setBranches] = useState([]);

  const getBranches = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/branches?provider_id=${providerId}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response);
      setBranches(response.data.data?.branches);
    } catch (error) {
      console.log();
    }
  };

  const [statusStates, setStatusStates] = useState([]);

  const getStatuses = async () => {
    try {
      const response = await axios.get(`${newHost}portal/batch_statuses`, {
        headers: newHeaders,
      });
      console.log(response);
      setStatusStates(response.data.data?.status_options);
    } catch (error) {
      console.log(error.mesaage);
    }
  };

  const [addMainCatigory, setAddMainCatigory] = useState({
    supplier_id: "",
    supplier_branch_id: "",
    purchase_price: "",
    selling_price: "",
    quantity: "",
    expiration_date: "",
    import_date: "",
    batch_code: "",
    status: "",
    received_at:'',
  });

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setAddMainCatigory({
      supplier_id: "",
      supplier_branch_id: "",
      purchase_price: "",
      selling_price: "",
      quantity: "",
      expiration_date: "",
      import_date: "",
      batch_code: "",
      status: "",
      received_at:'',
    });
    reset()
    setIsEditing(false);
    setEditBatchId(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEditing(false)
    setEditBatchId(null);
  };

  const onSubmitAddMainCatogiry = () => {

    const formData = new FormData();

    if (isEditing) {
      formData.append("_method", "PATCH");
    }

    formData.append("variation_id", productId);
    formData.append("supplier_id", addMainCatigory.supplier_id);
    formData.append("supplier_branch_id", addMainCatigory.supplier_branch_id);
    formData.append("purchase_price", addMainCatigory.purchase_price);
    formData.append("selling_price", addMainCatigory.selling_price);
    formData.append("quantity", addMainCatigory.quantity);
    formData.append("batch_code", addMainCatigory.batch_code);
    formData.append("status", addMainCatigory.status);
    formData.append("expiration_date",addMainCatigory.expiration_date);
    formData.append("import_date", addMainCatigory.import_date);
    formData.append("received_at", addMainCatigory.received_at);

    const url = isEditing
      ? `${newHost}portal/stock_batches/${editBatchId}`
      : `${newHost}portal/stock_batches`; ;

    axios
      .post(url, formData, {
        headers: newHeaders,
      })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isEditing
            ? "Batch Updated Successfully"
            : "New Batch Added Successfully",
          { autoClose: 3000 }
        );
        setShow(false);
        getBatches();
        setIsEditing(false)
        setAddMainCatigory({
          supplier_id: "",
          supplier_branch_id: "",
          purchase_price: "",
          selling_price: "",
          quantity: "",
          expiration_date: "",
          import_date: "",
          batch_code: "",
          status: "",
          received_at:'',
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const [isEditing, setIsEditing] = useState(false);

  const [editBatchId, setEditBatchId] = useState(null);

  const handleEditCategory = async (batchId) => {
    try {

      if (!branches.length) {
        await getBranches(); 
      }

      const response = await axios.get(
        `${newHost}portal/stock_batches/${batchId}`,
        {
          headers: newHeaders,
        }
      );

      const batch = response.data.data.stock_batch;

      const supplierId = String(batch?.supplier?.id);
      const branchId = String(batch?.supplier_branch?.id);

      setProviderId(supplierId);

      setAddMainCatigory({
        supplier_id: supplierId,
        supplier_branch_id: branchId,
        purchase_price: batch?.purchase_price,
        selling_price: batch?.selling_price,
        quantity: batch?.quantity,
        batch_code: batch?.batch_code,
        status: batch?.status,
        received_at: batch?.received_at?.slice(0, 10),
        import_date: batch?.import_date?.slice(0, 10),
        expiration_date: batch?.expiration_date?.slice(0, 10),
      });

      setValue("supplier_id", supplierId);
      setValue("supplier_branch_id", branchId);
      setValue("purchase_price", batch?.purchase_price);
      setValue("selling_price", batch?.selling_price);
      setValue("quantity", batch?.quantity);
      setValue("expiration_date", batch?.expiration_date);
      setValue("import_date", batch?.import_date);
      setValue("batch_code", batch?.batch_code);
      setValue("status", batch?.status);
      setValue("received_at", batch?.received_at);

      setIsEditing(true);
      setEditBatchId(batch?.id);
      setShow(true);
    } catch (error) {
      console.log(error);
    }
  };
  
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm();

  // delete batch
  
      const [showDelete, setShowDelete] = useState(false);
    
      const handleDeleteClose = () => {
        setShowDelete(false);
        setEditBatchId(null);
        handleClose();
      };
    
      const confirmDelete = (id) => {
        setShowDelete(true);
        setEditBatchId(id);
      };
    
      const deleteProduct = async () => {
        try {
          let response = await axios.delete(
            `${newHost}portal/stock_batches/${editBatchId}`,
            {
              headers: newHeaders,
            }
          );
          toast.warning("Batch Deleted successfully", { autoClose: 3000 });
          console.log(response);
          handleDeleteClose();
          getBatches();
        } catch (error) {
          toast.error("Failed To Delete This Product.");
          console.log(error.message);
        }
      };
  
  useEffect(() => {
    getBatches();
    getProviders();
    getStatuses();
    if (providerId) {
      getBranches();
    }
  }, [providerId]);

  return (
    <div>
      {/* Add Batches Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isEditing ? "Update Batch" : "Add New Batch"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddMainCatogiry)}>
            {/* supplier name */}
            <div className="row">
              <div className="col-12 ">
                <Controller
                  name="supplier_id"
                  control={control}
                  rules={{ required: "Supplier Name is required" }}
                  render={({ field }) => (
                    <FormControl
                      className="w-100 mb-3"
                      variant="outlined"
                      error={!!errors.supplier_id}
                    >
                      <InputLabel id="name-label">Supplier Name</InputLabel>
                      <Select
                        labelId="name-label"
                        id="supplier_id"
                        label="Supplier Name"
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          field.onChange(e);
                          setAddMainCatigory((prev) => ({
                            ...prev,
                            supplier_id: value,
                          }));
                          setProviderId(value);
                        }}
                      >
                        {providers.map((provider) => (
                          <MenuItem
                            className="custom-menu-item"
                            key={provider.id}
                            value={provider.id}
                          >
                            {provider.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                {errors.supplier_id && (
                  <p className="danger">{errors.supplier_id.message}</p>
                )}
              </div>
            </div>
            {/* Branch & Quantity  */}
            <div className="row">
              {/* Branch  */}
              <div className="col-6 ">
                <Controller
                  disabled={!providerId}
                  name="supplier_branch_id"
                  control={control}
                  rules={{ required: "Branch Name is required" }}
                  render={({ field }) => (
                    <FormControl
                      className="w-100 mb-3"
                      variant="outlined"
                      error={!!errors.supplier_branch_id}
                    >
                      <InputLabel id="branch-label">Supplier branch</InputLabel>
                      <Select
                        id="supplier_branch_id"
                        label="Supplier Branch"
                        labelId="branch-label"
                        {...field}
                        value={
                          field.value !== undefined ? String(field.value) : ""
                        }
                        onChange={(e) => {
                          field.onChange(e);
                          setAddMainCatigory((prev) => ({
                            ...prev,
                            supplier_branch_id: e.target.value,
                          }));
                        }}
                      >
                        {branches.map((branch) => (
                          <MenuItem
                            key={branch.id}
                            className="custom-menu-item"
                            value={branch.id}
                          >
                            {branch.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                {errors.supplier_branch_id && (
                  <p className="danger">{errors.supplier_branch_id.message}</p>
                )}
              </div>
              {/* Quantity  */}
              <div className="col-6 ">
                <TextField
                  className="w-100 mb-3"
                  type="number"
                  label="Quantity"
                  placeholder="Enter Number"
                  variant="outlined"
                  {...register("quantity", {
                    required: "Quantity Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        quantity: e.target.value,
                      });
                    },
                  })}
                  value={addMainCatigory.quantity}
                />
                {errors.quantity && (
                  <p className="danger">{errors.quantity.message}</p>
                )}
              </div>
            </div>
            {/* batchCode & status  */}
            <div className="row">
              {/* code  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-2"
                  label="Code Name"
                  placeholder="Enter Code"
                  variant="outlined"
                  value={addMainCatigory.batch_code}
                  {...register("batch_code", {
                    required: "Code Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        batch_code: e.target.value,
                      });
                    },
                  })}
                />
                {errors.batch_code && (
                  <p className="danger">{errors.batch_code.message}</p>
                )}
              </div>
              {/* status  */}
              <div className="col-6">
                <Controller
                  name="status"
                  control={control}
                  rules={{ required: "Status is required" }}
                  render={({ field }) => (
                    <FormControl
                      className="w-100 mb-2"
                      variant="outlined"
                      error={!!errors.status}
                    >
                      <InputLabel id="status-label">Status</InputLabel>
                      <Select
                        labelId="status-label"
                        label="Status"
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e);
                          setAddMainCatigory((prev) => ({
                            ...prev,
                            status: e.target.value,
                          }));
                        }}
                      >
                        {statusStates?.map((st) => (
                          <MenuItem
                            className="custom-menu-item"
                            key={st.value}
                            value={st.value}
                          >
                            {st.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* received_at  */}
            <div className="my-0">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DatePicker"]}
                  style={{ width: "100%" }}
                >
                  <DatePicker
                    label="Received_at Date"
                    sx={{ width: "100%" }}
                    value={
                      addMainCatigory.received_at
                        ? dayjs(addMainCatigory.received_at)
                        : null
                    }
                    onChange={(date) => {
                      setAddMainCatigory((prev) => ({
                        ...prev,
                        received_at: date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : null,
                      }));
                    }}
                  />
                  {/* <DatePicker
                    label="Received_at Date"
                    sx={{ width: "100%" }}
                    onChange={(date) => {
                      setAddMainCatigory((prev) => ({
                        ...prev,
                        received_at: date
                          ? dayjs(date).format("YYYY-MM-DD")
                          : null,
                      }));
                    }}
                  /> */}
                </DemoContainer>
              </LocalizationProvider>
            </div>
            {/* import & export  */}
            <div className="row">
              {/* import date  */}
              <div className="col-6 mt-0 mb-1">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {/* <DatePicker
                      label="Import Date"
                      onChange={(date) => {
                        setAddMainCatigory((prev) => ({
                          ...prev,
                          import_date: date
                            ? dayjs(date).format("YYYY-MM-DD")
                            : null,
                        }));
                      }}
                    /> */}
                    <DatePicker
                      label="Import Date"
                      value={
                        addMainCatigory.import_date
                          ? dayjs(addMainCatigory.import_date)
                          : null
                      }
                      onChange={(date) => {
                        setAddMainCatigory((prev) => ({
                          ...prev,
                          import_date: date
                            ? dayjs(date).format("YYYY-MM-DD")
                            : null,
                        }));
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              {/* export date  */}
              <div className="col-6 mt-0 mb-1">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {/* <DatePicker
                      label="Expiration Date"
                      onChange={(date) => {
                        setAddMainCatigory((prev) => ({
                          ...prev,
                          expiration_date: date
                            ? dayjs(date).format("YYYY-MM-DD")
                            : null,
                        }));
                      }}
                    /> */}
                    <DatePicker
                      label="Expiration Date"
                      value={
                        addMainCatigory.expiration_date
                          ? dayjs(addMainCatigory.expiration_date)
                          : null
                      }
                      onChange={(date) => {
                        setAddMainCatigory((prev) => ({
                          ...prev,
                          expiration_date: date
                            ? dayjs(date).format("YYYY-MM-DD")
                            : null,
                        }));
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
            </div>
            {/* purchase & selling  */}
            <div className="row">
              {/* purchase  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-3"
                  type="number"
                  label="Purchase Price "
                  placeholder="Enter Number"
                  variant="outlined"
                  {...register("purchase_price", {
                    required: "Purchase_price Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        purchase_price: e.target.value,
                      });
                    },
                  })}
                  value={addMainCatigory.purchase_price}
                />
                {errors.purchase_price && (
                  <p className="danger">{errors.purchase_price.message}</p>
                )}
              </div>
              {/* selling  */}
              <div className="col-6">
                <TextField
                  className="w-100 mb-3"
                  type="number"
                  label="Selling Price "
                  placeholder="Enter Number"
                  variant="outlined"
                  {...register("selling_price", {
                    required: "selling_price Is Required",
                    onChange: (e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        selling_price: e.target.value,
                      });
                    },
                  })}
                  value={addMainCatigory.selling_price}
                />
                {errors.selling_price && (
                  <p className="danger">{errors.selling_price.message}</p>
                )}
              </div>
            </div>
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* delete batch  */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this batch?"}
        deleteFunction={deleteProduct}
      />
      {/* Bar Code Details  */}
      <div className="mx-4 my-3">
        {/* head data  */}
        <div className="row mx-auto">
          <div className="col-12 text-center my-1 col-lg-2 px-0 text-lg-start my-lg-0">
            <h3 className="my-0">Product Profile</h3>
          </div>
          <div className="col-6 d-flex justify-content-center">
            <button
              onClick={goToProductInfo}
              className="btn border border-1 bg-light stock-button ms-5"
            >
              {" "}
              Product Info
            </button>
            <button className="btn btn-dark px-3 stock-button">
              {" "}
              Batches{" "}
            </button>
          </div>
          <div className="col-4 d-flex justify-content-end align-items-center px-0">
            <button
              // onClick={handleShowAddItem}
              style={{ backgroundColor: "#EA295E" }}
              className="btn border border-1 text-white stock-button me-2"
            >
              Suspend this product
            </button>
            <button
              onClick={() => handleShow()}
              className="btn border border-1 text-muted stock-button"
            >
              <i className="fa-solid fa-plus fw-light me-1"></i>
              Add Batches
            </button>
          </div>
        </div>
        {/* table  */}
        <div className="border border-2 rounded-3 my-3 p-3">
          {batches && batches.length > 0 ? (
            <div className="scrollable-table-wrapper">
              <div>
                <Paper sx={{ width: "100%" }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10, 15]}
                    checkboxSelection
                    sx={{
                      border: 0,
                    }}
                    slotProps={{
                      pagination: {
                        sx: {
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                      },
                    }}
                  />
                </Paper>
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Batches yet. All your Batches will appear here once you get started."
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
